import React from "react";
import { WizAuthority } from "@/containers/common";
import { framework_tool } from '@/tool'
const { ossFileUtils } = framework_tool

const getContentType = contentType => {
  switch(contentType) {
    case 1:
      return '文章';
    case 2:
      return '图片';
    case 3:
      return '视频'
    case 4:
      return '文档'
    case 5:
      return '下载文件'
  }
}

const getStatus = releaseState => {
  switch(releaseState) {
    case 0:
      return '草稿';
    case 1:
      return '已发布';
    case 2:
      return '取消发布'
    case 3:
      return '已关闭'
  }
}

const getPlatform = releasePlatform => {
  if(!releasePlatform) return
  const map = { '1': "PC", '2': 'APP'}
  const textArr = releasePlatform.toString().split(',');
  const arr = [];
  for (let index = 0; index < textArr.length; index++) {
    arr.push(map[textArr[index]])
  }
  return arr.join(',').replace(/\,/g, ' ')
}

export default (record={}) => {
  return [
    { label: '标题', value: record.title },
    { label: '摘要', value: record.remark },
    { label: '内容分类', value: record.categoryNames || record.categoryIds?.map(category => category.name)?.join(' ') },
    { label: '内容类型', value: getContentType(record.contentType) },
    { label: '作者', value: record.author },
    record.hiddenType === 0 ? { label: '标签', value: record.labelNames } : null,
    { label: '发布时间', value: record.releaseTime },
    // { label: '封面', value: record.fileUri? <img src={ ossFileUtils.getOssImgResizeUrl(record.fileUri,{ m: 'lfit', w: 555, h: 300 }) } /> : '无' },
    { label: '封面', value: record.img ? <img width={555} height={300} src={ getOssFilePath(record.img) } /> : '无' },
    { label: '受众', value: <WizAuthority value={record.targetScoreInfo} mode='Show' showBlock={false}/> },
    { label: '发布平台', value: getPlatform(record.releasePlatform) },
    { label: '点赞功能', value: record.switchLike === 1 ? '打开' : '关闭' },
    { label: '发布状态', value: getStatus(record.releaseState) },
    { label: '分享功能', value: record.switchShare === 1 ? '打开' : '关闭' },
    { label: '是否置顶', value: record.switchTop === 1 ? '是' : '否' },
    { label: '评论功能', value: record.switchComment === 1 ? '打开' : '关闭' },
  ].filter(item => !!item)
}
